import React, { useState, useEffect } from "react";
import styles from "./PracticeDetailsPage.module.scss";
import Header from "../Header/header";
import SetupSteps, { Step } from "../Register/SetupSteps/SetupSteps";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const STEPS: Step[] = [
  { key: "practice", label: "Practice and personal info" },
  { key: "logo", label: "Logo Management" },
  { key: "social", label: "Social Media Links" },
  { key: "portfolio", label: "Portfolio Gallery" },
  { key: "consent", label: "Consent Templates" },
  { key: "preview", label: "Preview & Complete" },
];

export default function PracticeDetailsPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    practiceName: "",
    practiceMobile: "",
    address: "",
    practiceEmail: "",
  });

  const [user, setUser] = useState<any>(null);
  const [practitioner, setPractitioner] = useState<any>(null);

  useEffect(() => {
    const fetchPracticeData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL_V2}onboarding/get_practice_data`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const mapped = {
          practiceName: res.data?.name || "",
          practiceMobile: res.data?.contact_no || "",
          address: res.data?.address || "",
          practiceEmail: res.data?.email || "",
        };
        setForm(mapped);
      } catch (err) {
        console.error("Error fetching practice data:", err);
      }
    };

    const getUserData = async () => {
      try {
        const { data } = await axios.get("/user");
        if (Array.isArray(data) && data.length > 1) {
          setUser(data[1]);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

   const fetchPractitionerData = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BASE_URL_V2}onboarding/get_practitioner_data`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    setPractitioner(res.data);
  } catch (err) {
    console.error("Error fetching practitioner data:", err);
  }
};


    fetchPractitionerData();
    fetchPracticeData();
    getUserData();
  }, []);

  const onBack = () => navigate(-1);

  return (
    <div className={styles.page}>
      <Header />

      <main className={styles.main}>
        <SetupSteps steps={STEPS} current={1} rightLabel="0% Complete" />

        <h1 className={styles.title}>Practice details</h1>
        <p className={styles.subtitle}>
          To create a consent request, you’ll need both your patient’s details
          and your practice information. Don’t worry, this information is
          pre-filled from DENTALLY, so just review and continue.
        </p>

        {/* ---------------- Practice Information ---------------- */}
        <section className={styles.card} aria-labelledby="practice-info">
          <h2 id="practice-info" className={styles.cardTitle}>
            Practice information
          </h2>

          <div className={styles.grid}>
            <div className={styles.field}>
              <label className={styles.label}>Name</label>
              <input className={styles.input} value={form.practiceName} disabled />
            </div>

            <div className={styles.field}>
              <label className={styles.label}>Mobile</label>
              <input className={styles.input} value={form.practiceMobile} disabled />
            </div>

            <div className={`${styles.field} ${styles.colSpanFull}`}>
              <label className={styles.label}>Address</label>
              <textarea
                className={`${styles.input} ${styles.textarea}`}
                rows={2}
                value={form.address}
                disabled
              />
            </div>

            <div className={styles.field}>
              <label className={styles.label}>Practice email</label>
              <input className={styles.input} value={form.practiceEmail} disabled />
            </div>
          </div>
        </section>

        {/* ---------------- Conditional Personal Info ---------------- */}
        {/* user */}
        {user?.level === "user" && practitioner && (
  <section className={styles.card} aria-labelledby="personal-info">
    <h2 id="personal-info" className={styles.cardTitle}>
      Personal information
    </h2>

    <div className={styles.grid}>
      <div className={styles.field}>
        <label className={styles.label}>Full name</label>
        <input
          className={styles.input}
          value={practitioner.name || ""}
          disabled
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Title/Credentials</label>
        <input
          className={styles.input}
          value={practitioner.role || ""}
          disabled
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Personal email</label>
        <input
          className={styles.input}
          value={practitioner.email || ""}
          disabled
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label}>GDC Number</label>
        <input
          className={styles.input}
          value={practitioner.gdc_number || ""}
          disabled
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label}>NHS Number</label>
        <input
          className={styles.input}
          value={practitioner.nhs_number || ""}
          disabled
        />
      </div>
    </div>
  </section>
)}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.btnSecondary}
            onClick={onBack}
          >
            Back
          </button>
          <button
            type="button"
            className={styles.btnPrimary}
            onClick={() => navigate("/logoManagement")}
          >
            Next
          </button>
        </div>
      </main>

      <footer className={styles.footer}>
        Copyright © Medicube 2025. All Rights Reserved.
      </footer>
    </div>
  );
}
